import React from 'react';

export default class CacheTable extends React.Component {

    render() {
        if (this.props.content.length === 0)
            return <></>;
        return <div className="cachemem-cache-table-container"><table className="cachemem-cache-table">
            <tbody>
                {this.props.content[this.props.step].map((row, ix) =>
                    <tr className="cachemem-cache-table-row" key={ix}>
                        {row.map((col, jx) => 
                            <td key={jx} className="cachemem-cache-table-col">
                                <div className="cachemem-cache-table-col-panel">
                                    <div className="cachemem-cache-table-col-tag">
                                    {this.props.markChanges && this.props.step > 0 && this.props.content[this.props.step][ix][jx] !== this.props.content[this.props.step-1][ix][jx] &&
                                        <><span className="cachemem-replace-item">{this.props.content[this.props.step-1][ix][jx]}</span> <span className="cachemem-hit-item">{this.props.content[this.props.step][ix][jx]}</span></>
                                    }
                                    {this.props.markChanges && this.props.step > 0 && this.props.content[this.props.step][ix][jx] === this.props.content[this.props.step-1][ix][jx] && this.props.address.index === ix && this.props.address.tag === this.props.content[this.props.step][ix][jx] &&
                                        <span className="cachemem-hit-item">{this.props.content[this.props.step][ix][jx]}✓</span>
                                    }
                                    {(!this.props.markChanges || this.props.step === 0 || (this.props.content[this.props.step][ix][jx] === this.props.content[this.props.step-1][ix][jx] && (this.props.address.index !== ix || this.props.address.tag !== this.props.content[this.props.step][ix][jx]))) &&
                                        <>{this.props.content[this.props.step][ix][jx]}</>
                                    }
                                    </div>
                                    {row.length > 1 &&
                                    <div className="cachemem-cache-table-col-age">
                                        {
                                        this.props.markChanges && this.props.step > 0 && this.props.ages[this.props.step][ix][jx] !== this.props.ages[this.props.step-1][ix][jx] &&
                                            <span className="cachemem-replace-item">{this.props.ages[this.props.step-1][ix][jx]}</span>
                                        }
                                        {this.props.ages[this.props.step][ix][jx]}
                                    </div>}
                                </div>
                            </td>
                        )}
                    </tr>
                )}
            </tbody>
        </table></div>;
    }
}
